import { OpenHours } from 'models/restaurant'

interface HoursOfOperationProps {
  openHours?: OpenHours
}

export function HoursOfOperation({ openHours }: HoursOfOperationProps) {
  if (!openHours || Object.keys(openHours).length === 0) {
    return null
  }

  // Define the order of days for the layout
  const daysOrder = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ]

  // Create array of day entries in the correct order
  const orderedEntries = daysOrder
    .map((day) => {
      const hours = openHours[day as keyof OpenHours]
      return hours ? { day, hours } : null
    })
    .filter((entry): entry is { day: string; hours: string } => entry !== null)

  return (
    <div className="flex flex-col gap-2">
      {/* Title */}
      <div className="text-sm font-medium text-fg leading-[1.04em]">
        Hours of Operation
      </div>

      {/* Two column grid layout */}
      <div className="flex gap-3">
        {/* Left column */}
        <div className="flex flex-col gap-3 w-[148px]">
          {orderedEntries
            .slice(0, Math.ceil(orderedEntries.length / 2))
            .map(({ day, hours }) => (
              <div key={day} className="flex flex-col gap-2">
                {/* Day name - Inter Light 300, 11px, 18px line-height */}
                <div className="uppercase font-light text-xs leading-[18px] text-fg-secondary">
                  {day}
                </div>
                {/* Hours - Inter Semi Bold 600, 16px, 18px line-height */}
                <div className="uppercase font-semibold text-base leading-[18px] text-fg">
                  {hours}
                </div>
              </div>
            ))}
        </div>

        {/* Right column */}
        <div className="flex flex-col gap-3 w-[148px]">
          {orderedEntries
            .slice(Math.ceil(orderedEntries.length / 2))
            .map(({ day, hours }) => (
              <div key={day} className="flex flex-col gap-2">
                {/* Day name - Inter Light 300, 11px, 18px line-height */}
                <div className="uppercase font-light text-xs leading-[18px] text-fg-secondary">
                  {day}
                </div>
                {/* Hours - Inter Semi Bold 600, 16px, 18px line-height */}
                <div className="uppercase font-semibold text-base leading-[18px] text-fg">
                  {hours}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}
